export interface BaseApiResponse<DataType> {
    data: DataType;
    status: number;
  }
  
  export const FETCH_STATUSES = {
    NEVER: "never",
    OK: "ok",
    ERROR: "error",
    LOADING: "loading"
  };
  
  export type FetchStatus =
    | typeof FETCH_STATUSES.NEVER
    | typeof FETCH_STATUSES.OK
    | typeof FETCH_STATUSES.ERROR
    | typeof FETCH_STATUSES.LOADING;
  
  export interface RemoteData<DataType = any> {
    data: DataType | null;
    status: FetchStatus;
  }
  